import { render, staticRenderFns } from "./TransferTab53.vue?vue&type=template&id=e04b0baa&scoped=true"
import script from "./TransferTab53.vue?vue&type=script&lang=js"
export * from "./TransferTab53.vue?vue&type=script&lang=js"
import style0 from "./TransferTab53.vue?vue&type=style&index=0&id=e04b0baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04b0baa",
  null
  
)

export default component.exports